// eslint-disable-next-line no-unused-vars
import notifications from './notifications';
import imageCarousel from './imageCarousel';
import fee from './fee';
import helpers from './helpers';

// polyfill for Number.isNaN
Number.isNaN = Number.isNaN || function isNaN(input) {
  // eslint-disable-next-line no-self-compare
  return typeof input === 'number' && input !== input;
};

function updatePickUpValue(event, pickUpButtons) {
  const newValue = event.target.value;
  document.getElementById('pickupvalue').value = newValue;
  if (newValue === true || newValue === 'true') {
    pickUpButtons[0].classList.add('pick-up__button--active');
    pickUpButtons[1].classList.remove('pick-up__button--active');
  } else {
    pickUpButtons[1].classList.add('pick-up__button--active');
    pickUpButtons[0].classList.remove('pick-up__button--active');
  }
}

function bidTime() {
  const d = new Date();
  const seconds = d.getSeconds().toString().length === 1 ? `0${d.getSeconds()}` : d.getSeconds();
  const minutes = d.getMinutes().toString().length === 1 ? `0${d.getMinutes()}` : d.getMinutes();
  const hours = d.getHours().toString().length === 1 ? `0${d.getHours()}` : d.getHours();
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  return `${d.getDate()} ${months[d.getMonth()]} ${hours}:${minutes}:${seconds}`;
}

function finalizeRequest(bid, bidMessage, historyTxt) {
  const $largeNotification = $('#largeNotification');

  if (!$('div.bidhistory').length) {
    $('.col-lg-6.hidden-xs').prepend(`${'<div class="panel panel-primary panel-lg visible-lg"><div class="panel-heading panel-heading-lg">'
      + '<h4 class="panel-title-lg">'}${historyTxt}</h4></div><div class="bidhistory panel-body"></div>`);
    $('.panel-group.visible-xs').prepend(
      `<div class="panel panel-primary"><div class="panel-heading collapseclose"  id="bidhistorypanel-heading"><h4 class="panel-title"><a data-toggle="collapse" data-parent="#accordion" href="#bidhistorypanel">${historyTxt}<span class="glyphicon glyphicon-chevron-right pull-right arrow hidden-print"></span></a></h4></div>`
      + '<div id="bidhistorypanel" class="panel-collapse collapse"><div class="panel-body bidhistorymobile"></div></div>',
    );
  }
  $('.bidhistory').first().prepend(`<div class="bidhistory"><div class="col-xs-5 ie-half"><p>${bidTime()}</p></div><div class="col-xs-7 ie-half"><p>${bid}</p></div></div>`);
  $('.bidhistorymobile').first().prepend(`<div class="row bidhistory"><div class="col-xs-6 ie-half"><p>${bidTime()}</p></div><div class="col-xs-6 ie-half" style="color: #278fbf"><p>${bid}</p></div></div>`);
  notifications.showLargeNotificationPanel();
  notifications.unselectAll();
  $largeNotification.html(`<div id='bid-notification'><h3>${bidMessage}</h3><button type='button' class='btn btn-primary btn-lg btn-block'>Ok</button></div>`);
  $largeNotification.find('button').focus();
}

/**
 * Make bid and display result
 *
 * Returns a lambda function
 *
 * @param string successtxt
 * @param string historytxt
 */
function bidSubmitJs(successTxt, historyTxt) {
  return (event) => {
    const $button = $('#bidSubmit');

    if (typeof event.preventDefault === 'function') {
      event.preventDefault();
    }

    const doesAgree = document.getElementById('agree').checked;
    const emptyBid = document.getElementById('bid').value.length === 0;

    if (doesAgree && !emptyBid) {
      $button.addClass('_ajax_loading');

      $.ajax({
        url: event.target.action,
        data: $(event.target).serialize(),
        dataType: 'json',
        type: 'post',
        success(data) {
          let bid = 0;
          let bidMessage = 'Unkown error';

          if (typeof (data.bid) !== 'undefined' && !Number.isNaN(Number(data.bid))) {
            bid = helpers.formatAmount(data.bid);
            bidMessage = `${successTxt}<br><br>${bid}`;
          }

          finalizeRequest(bid, bidMessage, historyTxt);
        },
        error(data) {
          const jsonData = data.responseJSON;
          let bidMessage = 'Unknown error';

          if (typeof (jsonData.message) !== 'undefined') {
            bidMessage = jsonData.message;
          }

          finalizeRequest(0, bidMessage, historyTxt);
        },
      });
    } else if (!doesAgree) {
      $('#largeNotification').html("<div id='bid-notification'><h3>Ga eerst akkoord met de voorwarden</h3><button type='button' class='btn btn-primary btn-lg btn-block'>Ok</button></div>");
    }
  };
}

$('#submitA').click(() => {
  $.post('/favourites', `${$('#favoriteformA').serialize()}&favorite=0`)
    .done(() => {
      $('#submitA').hide().addClass('hidden');
      $('#submitB').show().removeClass('hidden');
    });
});

$('#submitB').click(() => {
  $.post('/favourites', `${$('#favoriteformA').serialize()}&favorite=1`)
    .done(() => {
      $('#submitB').hide().addClass('hidden');
      $('#submitA').show().removeClass('hidden');
    });
});

function toggleCollapseArrow($target) {
  const i = $target.parent().find('.arrow');
  i.toggleClass('glyphicon-chevron-right glyphicon-chevron-down');
}

$('.panel-heading').on('click', () => {
  $(this).parent().parent().find('.collapse.in')
    .collapse('toggle');
  $(this).parent().find('.collapse').collapse('toggle');
  toggleCollapseArrow($(this));
});

$(() => {
  const data = document.getElementById('js-data');
  if (data) {
    const { vehicleType } = data.dataset;
    const { bidSuccess } = data.dataset;
    const { bids } = data.dataset;
    const pickUpButtons = document.getElementsByClassName('pick-up__button');

    for (let i = 0; i < pickUpButtons.length; i += 1) {
      pickUpButtons[i].addEventListener('click', (event) => {
        updatePickUpValue(event, pickUpButtons);
      });
    }

    $('[data-toggle="popover"]').popover({
      trigger: 'hover',
    });

    fee.getHandlingfee(vehicleType);

    $('form.bidForm').submit(
      bidSubmitJs(
        bidSuccess,
        bids,
      ),
    );
  }

  $('.pleaseHideMe').click(() => {
    $('#largeNotificationPanel').css('visibility', 'hidden');
    $('#largeImgPanel').css('visibility', 'hidden');
    $('#largeSingleImgPanel').css('visibility', 'hidden');
  });

  $('.carousel-img').click((event) => {
    imageCarousel.showImage(event);
  });

  $('.single-image').click((event) => {
    imageCarousel.showSingleImage(event);
  });
});
